import React from 'react'
import styled from 'styled-components'

export type TextTitleModuleItem = {
  text: React.ReactNode
  color?: string
  fontSize?: number | string
  fontWeight?: number | string
  lineHeight?: number | string
  textAlign?: 'left' | 'center' | 'right'
  backgroundColor?: string
  padding?: string
  margin?: string
}

type Props = {
  moduleItem: TextTitleModuleItem
  wrapperStyle?: React.CSSProperties
}

export const TextTitleModule: React.FC<Props> = ({ moduleItem, wrapperStyle }) => {
  const { text, ...styleProps } = moduleItem
  return (
    <TextView
      style={wrapperStyle}
      $color={styleProps.color}
      $fontSize={styleProps.fontSize}
      $fontWeight={styleProps.fontWeight}
      $lineHeight={styleProps.lineHeight}
      $textAlign={styleProps.textAlign}
      $backgroundColor={styleProps.backgroundColor}
      $padding={styleProps.padding}
      $margin={styleProps.margin}
    >
      {text}
    </TextView>
  )
}

const TextView = styled.div<{
  $color?: string
  $fontSize?: number | string
  $fontWeight?: number | string
  $lineHeight?: number | string
  $textAlign?: 'left' | 'center' | 'right'
  $backgroundColor?: string
  $padding?: string
  $margin?: string
}>`
  background-color: ${p => p.$backgroundColor ?? ''};
  padding: ${p => p.$padding ?? '0 20px 0 20px'};
  margin: ${p => p.$margin ?? '0'};
  color: ${p => p.$color ?? 'rgba(0,0,0,0.85)'};
  font-size: ${p => (p.$fontSize === undefined ? '16px' : typeof p.$fontSize === 'number' ? `${p.$fontSize}px` : p.$fontSize)};
  font-weight: ${p => p.$fontWeight ?? 600};
  line-height: ${p => (p.$lineHeight === undefined ? '22px' : typeof p.$lineHeight === 'number' ? `${p.$lineHeight}px` : p.$lineHeight)};
  text-align: ${p => p.$textAlign ?? 'left'};

`

